export default __webpack_public_path__ + "static/media/cage2.aa6e1d3d.svg";